import React from 'react';
import { useIntl } from 'react-intl';
import gql from 'graphql-tag';
import { widget } from '../../../../src/web/components/widgets/decorators';
import compose from '../../../../src/web/utils/react/compose';
import useQuery from '../../../../modules/react/hooks/useQuery';
import ReviewStars from './ReviewStars';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';

export const GET_FACILITIES = gql`
  query GetFacilities($live: Boolean!, $locale: String!) {
    facilities(filter: { live: $live, locale: $locale }) {
      edges {
        node {
          id
          name
          ...ReviewStars
        }
      }
    }
  }

  ${ReviewStars.fragments.reviews}
`;

const ReviewStarsContainer = ({ ...rest }) => {
  const { locale } = useIntl();

  const { data } = useQuery(GET_FACILITIES, { variables: { live: true, locale } });

  const facilities = data ? data.facilities.edges.map(({ node }) => node) : [];

  return <ReviewStars facilities={facilities} {...rest} />;
};

const component = compose(
  widget(
    { name: NAME, category: 'Reviews', componentId: ID },
  ),
)(ReviewStarsContainer);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
